/**
 * Persist deferred-deep-link attribution to Firestore when a deep link carried
 * "dlcode" (the /l/:code that resolved into this session). Saves the user and
 * deep link details in the "affilateUsers" collection — same pattern as
 * affiliatesFirestore.ts's "aid" handling.
 */
import { getFirestore, collection, doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { firebaseApp } from './firebaseConfig';

const COLLECTION = 'affilateUsers';

function sanitizeId(s: string): string {
  return s.replace(/[./#[\]@]/g, '_');
}

/**
 * Save deep link attribution: userId + deep link code + resolved destination
 * in collection "affilateUsers". Only writes if no record exists for this
 * userId + code (avoids duplicate saves).
 */
export async function saveDeepLinkUserToFirestore(
  userId: string,
  code: string,
  path: string,
  params: Record<string, string>,
): Promise<void> {
  if (!userId.trim() || !code.trim()) return;
  const db = getFirestore(firebaseApp);
  const docId = `${sanitizeId(userId)}_${sanitizeId(code)}`;
  const ref = doc(collection(db, COLLECTION), docId);
  const existing = await getDoc(ref);
  if (existing.exists()) return;
  await setDoc(ref, {
    userId,
    code,
    path,
    params,
    updatedAt: serverTimestamp(),
  });
}
